import React, { useState, useEffect } from 'react';
import {
	Button,
	Col,
	Input,
	Row,
	Label,
	ModalBody,
	Form,
	TabPane,
	TabContent,
	FormFeedback,
	ModalFooter,
} from 'reactstrap';

// Formik
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';

import { getOriginTypeList, getResidueCategoryList, getResidueList, getResidueTypeList, getUnitMeasurementList } from '../../../helpers/residue/backend_helper';
import OSelect from '../../../Components/OElements/OSelect';
import { toSmartTitleCase } from '../../../utils/toSmartTitleCase';

const ResidueCollectedForm = ({
    dataResidueCollected,
	isEdit,
	handleToggleModal,
	isOpen,
    residuesCollectedList,
	handleResiduesCollectedList
}) => {
	const [selectedResidue, setSelectedResidue] = useState(null);
	const [selectedUnitMeasurement, setSelectedUnitMeasurement] = useState(null);
	const [selectedOriginType, setSelectedOriginType] = useState(null);

	const handleResidueSelected = (optionSelected) => {
		setSelectedResidue(optionSelected);
	};

	const handleUnitMeasurementSelected = (optionSelected) => {
		setSelectedUnitMeasurement(optionSelected);
	};

	const handleOriginTypeSelected = (optionSelected) => {
		setSelectedOriginType(optionSelected);
	};

	const getResidueCollectedIdentity = residueCollected => (
		residueCollected?.id ||
		residueCollected?._id ||
		residueCollected?.residue_id ||
		residueCollected?.residue?.id ||
		residueCollected?.residue?._id ||
		null
	);

	const getResidueDisplayName = residue => {
		if (!residue) return '-';
		return toSmartTitleCase(residue?.name || '');
	};

	const getEntityId = entity => (
		entity?.id || entity?._id || ''
	);

	// validation
	const validation = useFormik({
		// enableReinitialize: use this flag when initial values needs to be changed
		enableReinitialize: true,
		initialValues: {
            residue_type_id: '',
			residue_category_id: '',
			residue_id: '',
			unit_measurement_id: '',
			amount: '',
			kilograms: '',
            origin_type_id: ''
		},
		validationSchema: Yup.object({
			residue_type_id: Yup.string().required('Campo requerido'),
			residue_category_id: Yup.string().required('Campo requerido'),
			residue_id: Yup.string().required('Campo requerido'),
			unit_measurement_id: Yup.string().required('Campo requerido'),
			amount: Yup
				.number()
				.typeError('Campo requerido')
				.required('Campo requerido')
				.test(
					'Validacion cantidad minima',
					'La cantidad debe ser mayor a 0',
					(value) => Number(value) > 0
				),
			origin_type_id: Yup.string().required('Campo requerido'),
		}),
		onSubmit: values => {
			const selectedOrCurrentResidue = selectedResidue || dataResidueCollected?.residue || null;
			const selectedOrCurrentUnit = selectedUnitMeasurement || dataResidueCollected?.unit_measurement || null;
			const selectedOrCurrentOrigin = selectedOriginType || dataResidueCollected?.origin_type || null;
			const originalResidueCollectedId = getResidueCollectedIdentity(dataResidueCollected);
			const residueId = values.residue_id || getEntityId(selectedOrCurrentResidue);
			const residueTypeId = values.residue_type_id || dataResidueCollected?.residue_type_id || dataResidueCollected?.residue?.residue_category?.residue_type_id || dataResidueCollected?.residue?.residue_category?.residue_type?.id || dataResidueCollected?.residue?.residue_category?.residue_type?._id;
			const residueCategoryId = values.residue_category_id || dataResidueCollected?.residue_category_id || getEntityId(dataResidueCollected?.residue?.residue_category);
			const unitMeasurementId = values.unit_measurement_id || getEntityId(selectedOrCurrentUnit) || dataResidueCollected?.unit_measurement_id;
			const originTypeId = values.origin_type_id || getEntityId(selectedOrCurrentOrigin) || dataResidueCollected?.origin_type_id;

			if (!residueId) {
				toast.error('Debe seleccionar un residuo.', { autoClose: 3000 });
				return;
			}

			const newResidueCollected = {
				...(dataResidueCollected?.id && { id: dataResidueCollected.id }),
				...(dataResidueCollected?._id && { _id: dataResidueCollected._id }),
				residue_type_id: residueTypeId,
				residue_category_id: residueCategoryId,
				residue_id: residueId,
				residue:
					selectedOrCurrentResidue || {
						id: residueId,
						_id: residueId,
						name: '',
					},
				unit_measurement_id: unitMeasurementId,
				unit_measurement:
					selectedOrCurrentUnit || {
						id: unitMeasurementId,
						_id: unitMeasurementId,
						name: '',
					},
				amount: values.amount,
				kilograms: values.kilograms,
				origin_type_id: originTypeId,
				origin_type:
					selectedOrCurrentOrigin || {
						id: originTypeId,
						_id: originTypeId,
						name: '',
					},
			};

				const isAdded = handlerItemResidueCollected(newResidueCollected, originalResidueCollectedId);
				if (isAdded) {
					handleToggleModal(!isOpen);
				}
				if (isAdded && !isEdit) {
					validation.setFieldValue('residue_type_id', '');
					validation.setFieldValue('residue_category_id', '');
					validation.setFieldValue('residue_id', '');
					validation.setFieldValue('unit_measurement_id', '');
					validation.setFieldValue('amount', '');
					validation.setFieldValue('kilograms', '');
					validation.setFieldValue('origin_type_id', '');
					validation.setFieldTouched('amount', false);
			}
		},
	});

		function handlerItemResidueCollected(newResidueCollected, originalResidueCollectedId = null) {
		let residueAdded = false;
			let isError = false;
			const newResidueId = newResidueCollected?.residue?.id || newResidueCollected?.residue?._id || newResidueCollected?.residue_id;
		const residueCollectedFounded = residuesCollectedList.find(residueCollected => (
			(
					(residueCollected?.residue?.id || residueCollected?.residue?._id || residueCollected?.residue_id) === newResidueId
			) &&
				getResidueCollectedIdentity(residueCollected) !== originalResidueCollectedId
			));

			if (residueCollectedFounded && !isEdit) {
				isError = true;
				toast.error(`Ya existe el residuo recolectado "${getResidueDisplayName(newResidueCollected.residue)}".`, { autoClose: 3000 });
			}

			if (residueCollectedFounded && isEdit) {
				isError = true;
				toast.error(`Ya existe el residuo recolectado "${getResidueDisplayName(newResidueCollected.residue)}".`, { autoClose: 3000 });
			}

			if (!isEdit && !isError) {
			handleResiduesCollectedList([...residuesCollectedList, newResidueCollected]);
			residueAdded = true;
				toast.success(`Residuo recolectado ${getResidueDisplayName(newResidueCollected.residue)} agregado exitosamente.`, { autoClose: 3000 });
		}

			if (isEdit && !isError) {
			const updatedResiduesCollectedList = residuesCollectedList.map(residueCollected => {
				if (
						getResidueCollectedIdentity(residueCollected) == originalResidueCollectedId
					) {
					return { ...residueCollected, ...newResidueCollected }
				} else {
					return residueCollected
				}
			});
			handleResiduesCollectedList(updatedResiduesCollectedList);
			residueAdded = true;
				toast.success(`Residuo recolectado "${getResidueDisplayName(newResidueCollected.residue)}" actualizado exitosamente.`, { autoClose: 3000 });
		}

		return residueAdded;
	}

	useEffect(() => {
		if (validation.values.amount) {
			const total = calculateTotal(validation.values.amount);
			validation.setFieldValue('kilograms', total);
		} else {
			validation.setFieldValue('kilograms', '');
		}
	}, [validation.values.amount]);

	const calculateTotal = (amount) => {
		return amount;
	};

	useEffect(() => {
		if (dataResidueCollected) {
			validation.setFieldValue('origin_type_id', dataResidueCollected.origin_type_id || getEntityId(dataResidueCollected.origin_type));
			validation.setFieldValue('residue_type_id', dataResidueCollected.residue_type_id || dataResidueCollected.residue?.residue_category?.residue_type_id || dataResidueCollected.residue?.residue_category?.residue_type?.id || dataResidueCollected.residue?.residue_category?.residue_type?._id || '');
			validation.setFieldValue('residue_category_id', dataResidueCollected.residue_category_id || getEntityId(dataResidueCollected.residue?.residue_category));
			validation.setFieldValue('residue_id', dataResidueCollected.residue_id || getEntityId(dataResidueCollected.residue));
			validation.setFieldValue('unit_measurement_id', dataResidueCollected.unit_measurement_id || getEntityId(dataResidueCollected.unit_measurement));
			validation.setFieldValue('amount', dataResidueCollected.amount || '');
			validation.setFieldValue('kilograms', dataResidueCollected.kilograms || '');
		}
	}, [dataResidueCollected]);

	return (
		<Form
			className='tablelist-form'
			onSubmit={e => {
				e.preventDefault();
				return false;
			}}
		>
			<ModalBody className='modal-body'>
				<TabContent activeTab={'1'}>
					<TabPane tabId='1'>
						<Row className='g-3'>
							<Col lg={6}>
								<OSelect
									key={`origin_type_id` || ''}
									label='Tipo De Origen'
									id='origin_type_id'
									name='origin_type_id'
									value={validation.values.origin_type_id || ''}
									onSelect={handleOriginTypeSelected}
									requestApi={() => getOriginTypeList()}
									isRequired
									disabled={false}
									validation={validation}
								/>
							</Col>
                            <Col lg={6}>
								<OSelect
									key={`residue_type_id` || ''}
									label='Tipo de Residuo'
									id='residue_type_id'
									name='residue_type_id'
									value={validation.values.residue_type_id || ''}
									onSelect={optionSelected => {
										const selectedResidueTypeId = getEntityId(optionSelected);
										if (selectedResidueTypeId !== validation.values.residue_type_id) {
											validation.setFieldValue('residue_category_id', '');
											validation.setFieldValue('residue_id', '');
										}
									}}
									requestApi={() => getResidueTypeList()}
									isRequired
									disabled={false}
									validation={validation}
								/>
							</Col>
                            <Col lg={12}>
								<OSelect
									key={`${getEntityId(dataResidueCollected?.residue?.residue_category)}${validation.values['residue_type_id']}` || ''}
									label='Categoría de Residuo'
									id='residue_category_id'
									name='residue_category_id'
									value={validation.values.residue_category_id || ''}
									onSelect={optionSelected => {
										const selectedResidueCategoryId = getEntityId(optionSelected);
										if (selectedResidueCategoryId !== validation.values.residue_category_id) {
											validation.setFieldValue('residue_id', '');
										}
									}}
									requestApi={() => getResidueCategoryList(
                                        {'residue_type_id': validation.values['residue_type_id']}
                                    )}
									isRequired
									disabled={validation.values['residue_type_id'] == ''}
									validation={validation}
								/>
							</Col>
							<Col lg={12}>
								<OSelect
									key={`${getEntityId(dataResidueCollected?.residue)}${validation.values['residue_category_id']}` || ''}
									label='Residuo'
									id='residue_id'
									name='residue_id'
									value={validation.values.residue_id || ''}
									onSelect={handleResidueSelected}
									requestApi={() => getResidueList({
										residue_category_id: validation.values['residue_category_id']
									})}
									isRequired
									disabled={(
										validation.values['residue_category_id'] == ''
									)}
									validation={validation}
								/>
							</Col>
							<Col lg={4}>
								<OSelect
									key={getEntityId(dataResidueCollected?.unit_measurement) || ''}
									label='Unidad de Medida'
									id='unit_measurement_id'
									name='unit_measurement_id'
									value={validation.values.unit_measurement_id || ''}
									onSelect={handleUnitMeasurementSelected}
									requestApi={() => getUnitMeasurementList()}
									isRequired
									validation={validation}
								/>
							</Col>
							<Col lg={4}>
								<Label for='amount' className='form-label'>
									Cantidad <span className='text-danger'>*</span>
								</Label>
								<Input
									name='amount'
									id='amount'
									className='form-control'
									placeholder='Ingrese una cantidad'
									type='number'
									validate={{ required: { value: true } }}
									onChange={validation.handleChange}
									onBlur={validation.handleBlur}
									value={validation.values.amount || ''}
									invalid={
										validation.touched.amount &&
											validation.errors.amount
											? true
											: false
									}
								/>
								{
									validation.touched.amount &&
										validation.errors.amount ? (
										<FormFeedback type='invalid'>
											{validation.errors.amount}
										</FormFeedback>
									) : null
								}
							</Col>
							<Col lg={4}>
								<Label for='kilograms' className='form-label'>
									Total Kilogramos
								</Label>
								<Input
									name='kilograms'
									id='kilograms'
									className='form-control'
									type='number'
									disabled
									value={validation.values.kilograms || ''}
									invalid={
										validation.touched.kilograms &&
											validation.errors.kilograms
											? true
											: false
									}
								/>
								{
									validation.touched.kilograms &&
										validation.errors.kilograms ? (
										<FormFeedback type='invalid'>
											{validation.errors.kilograms}
										</FormFeedback>
									) : null
								}
							</Col>
						</Row>
					</TabPane>
				</TabContent>
			</ModalBody>
			<ModalFooter>
				<div className='hstack gap-2 justify-content-end'>
					<Button
						type='button'
						onClick={() => {
							handleToggleModal();
						}} className='btn-danger btn-label'>
						<i className="icon-x label-icon"></i>
						Cancelar
					</Button>
					<button
						type='button'
						className='btn btn-label btn-primary'
						onClick={() => {
							validation.handleSubmit();
						}}
					>
						<i className='ri-save-line label-icon'></i>
						Guardar
					</button>
				</div>
			</ModalFooter>
		</Form>
	);
};

export default ResidueCollectedForm;
